import Modal from '../Modal';
import styles from './ConfirmModal.module.scss';
import { Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import clx from 'classnames';

const ConfirmModal = ({
  isModalOpen,
  setIsModalOpen,
  title,
  subtitle,
  content,
  action,
  Icon,
  variant = 'default',
  confirmLabel,
  cancelLabel,
  width = '420px',
}) => {
  const { t } = useTranslation();
  const isDanger = variant === 'danger';

  return (
    <Modal
      width={width}
      maxWidth="min(420px, calc(100vw - 32px))"
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      centered
      borderRadius="16px"
    >
      <div
        className={clx(styles.modal__content, {
          [styles.modal__content_danger]: isDanger,
        })}
      >
        {Icon ? (
          <div
            className={clx(styles.icon_badge, {
              [styles.icon_badge_danger]: isDanger,
            })}
          >
            <Icon className={styles.icon} aria-hidden />
          </div>
        ) : null}

        <div className={styles.text_block}>
          <div className={styles.title}>{title}</div>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          {content ? <div className={styles.content}>{content}</div> : null}
        </div>

        <div className={styles.modal__actions}>
          <Button
            onClick={() => setIsModalOpen(false)}
            className={styles.return_button}
          >
            {cancelLabel || t('common.actions.no')}
          </Button>
          <Button
            className={clx(styles.confirm_button, {
              [styles.confirm_button_danger]: isDanger,
            })}
            variant="contained"
            onClick={action}
          >
            {confirmLabel || t('common.actions.yes')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
